"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwErrorAsync = void 0;

var throwErrorAsync = function throwErrorAsync(error) {
  setTimeout(function () {
    throw error;
  }, 0);
};

exports.throwErrorAsync = throwErrorAsync;